exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hPa-control[data-v-f2d11c0c]{font-size:12px}.slider-title[data-v-f2d11c0c]{margin-bottom:1rem}.slider-title__text[data-v-f2d11c0c]{transform:translateX(-0.25rem);display:inline-block;font-size:.75rem;letter-spacing:.5px;line-height:1.33}", ""]);

